import { FlightSearchBarActions, FlightSearchBarActionType } from './actions';
import { IFlightSearchBarState } from './state';

const flightSearchBarReducer = (
  state: IFlightSearchBarState,
  action: FlightSearchBarActions
): IFlightSearchBarState => {
  const { type, payload } = action;

  switch (type) {
    case FlightSearchBarActionType.SET_START_DATE:
      return {
        ...state,
        startDate: payload,
      };

    case FlightSearchBarActionType.SET_END_DATE:
      return {
        ...state,
        endDate: payload,
      };

    case FlightSearchBarActionType.SET_GUESTS:
      return {
        ...state,
        guestInfo: payload,
      };

    case FlightSearchBarActionType.SET_ARRIVAL_AIRPORT:
      return {
        ...state,
        arrivalAirport: payload,
      };

    case FlightSearchBarActionType.SET_DEPARTURE_AIRPORT:
      return {
        ...state,
        departureAirport: payload,
      };

    case FlightSearchBarActionType.SET_IS_ONE_WAY:
      return {
        ...state,
        isOneWay: payload,
        ...(payload && { endDate: null }),
      };

    case FlightSearchBarActionType.SET_IS_DIRECT_FLIGHT:
      return {
        ...state,
        isDirectFlight: payload,
      };

    case FlightSearchBarActionType.SET_IS_VALID_FLIGHT_SEARCH_BAR:
      return {
        ...state,
        isValidFlightSearchBar: payload,
      };

    case FlightSearchBarActionType.SET_IS_SUBMIT:
      return {
        ...state,
        isSubmit: payload,
      };

    case FlightSearchBarActionType.SET_CABIN_CLASS:
      return {
        ...state,
        cabinClass: payload,
      };

    default:
      return state;
  }
};

export default flightSearchBarReducer;
